'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var CID = require('cids');

var Message = require('../types/message');

var WantType = Message.WantType;

var Wantlist = require('../types/wantlist');

var Ledger = require('./ledger');

var RequestQueue = require('./req-queue');

var TaskMerger = require('./task-merger');

var _require = require('../utils'),
    logger = _require.logger; // The ideal size of the batched payload. We try to pop this much data off the
// request queue, but
// - if there isn't any more data in the queue we send whatever we have
// - if there are several small items in the queue (eg HAVE response) followed
//   by one big item (eg a block) that would exceed this target size, we
//   include the big item in the message


var TARGET_MESSAGE_SIZE = 16 * 1024; // If the client sends a want-have, and the engine has the corresponding block,
// we check the size of the block and if it's small enough we send the block
// itself, rather than sending a HAVE.
// This constant defines the maximum size up to which we replace a HAVE with
// a block.

var MAX_SIZE_REPLACE_HAS_WITH_BLOCK = 1024;

var DecisionEngine = /*#__PURE__*/function () {
  function DecisionEngine(peerId, blockstore, network, stats, opts) {
    _classCallCheck(this, DecisionEngine);

    this._log = logger(peerId, 'engine');
    this.blockstore = blockstore;
    this.network = network;
    this._stats = stats;
    this._opts = this._processOpts(opts); // A list of of ledgers by their partner id

    this.ledgerMap = new Map();
    this._running = false; // Queue of want-have / want-block per peer

    this._requestQueue = new RequestQueue(TaskMerger);
  }

  _createClass(DecisionEngine, [{
    key: "_processOpts",
    value: function _processOpts(opts) {
      return _objectSpread({
        maxSizeReplaceHasWithBlock: MAX_SIZE_REPLACE_HAS_WITH_BLOCK,
        targetMessageSize: TARGET_MESSAGE_SIZE
      }, opts);
    }
  }, {
    key: "_scheduleProcessTasks",
    value: function _scheduleProcessTasks() {
      var _this = this;

      setTimeout(function () {
        _this._processTasks();
      });
    } // Pull tasks off the request queue and send a message to the corresponding
    // peer

  }, {
    key: "_processTasks",
    value: function () {
      var _processTasks2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$_requestQueue$p, peerId, tasks, pendingSize, msg, blockCids, blockTasks, _iterator, _step, task, cid, blocks, _iterator2, _step2, _step2$value, topic, taskData, blk, _cid, _iterator3, _step3, block;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._running) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this$_requestQueue$p = this._requestQueue.popTasks(this._opts.targetMessageSize), peerId = _this$_requestQueue$p.peerId, tasks = _this$_requestQueue$p.tasks, pendingSize = _this$_requestQueue$p.pendingSize;

                if (!(tasks.length === 0)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                // Create a new message
                msg = new Message(false); // Amount of data in the request queue still waiting to be popped

                msg.setPendingBytes(pendingSize); // Split out want-blocks, want-haves and DONT_HAVEs

                blockCids = [];
                blockTasks = new Map();
                _iterator = _createForOfIteratorHelper(tasks);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    task = _step.value;
                    cid = new CID(task.topic);

                    if (task.data.haveBlock) {
                      if (task.data.isWantBlock) {
                        blockCids.push(cid);
                        blockTasks.set(task.topic, task.data);
                      } else {
                        // Add HAVES to the message
                        msg.addHave(cid);
                      }
                    } else {
                      // Add DONT_HAVEs to the message
                      msg.addDontHave(cid);
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context.next = 13;
                return this._getBlocks(blockCids);

              case 13:
                blocks = _context.sent;
                _iterator2 = _createForOfIteratorHelper(blockTasks);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _step2$value = _slicedToArray(_step2.value, 2), topic = _step2$value[0], taskData = _step2$value[1];
                    blk = blocks.get(topic); // If the block was found (it has not been removed)

                    if (blk) {
                      // Add the block to the message
                      msg.addBlock(blk);
                    } else {
                      // The block was not found. If the client requested DONT_HAVE,
                      // add DONT_HAVE to the message.
                      if (taskData.sendDontHave) {
                        _cid = new CID(topic);
                        msg.addDontHave(_cid);
                      }
                    }
                  } // If there's nothing in the message, bail out

                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (!msg.empty) {
                  _context.next = 20;
                  break;
                }

                this._requestQueue.tasksDone(peerId, tasks); // Trigger the next round of task processing


                this._scheduleProcessTasks();

                return _context.abrupt("return");

              case 20:
                _context.prev = 20;
                _context.next = 23;
                return this.network.sendMessage(peerId, msg);

              case 23:
                // Peform sent message accounting
                _iterator3 = _createForOfIteratorHelper(blocks.values());

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    block = _step3.value;
                    this.messageSent(peerId, block);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](20);

                this._log.error(_context.t0);

              case 30:
                // Free the tasks up from the request queue
                this._requestQueue.tasksDone(peerId, tasks); // Trigger the next round of task processing


                this._scheduleProcessTasks();

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[20, 27]]);
      }));

      function _processTasks() {
        return _processTasks2.apply(this, arguments);
      }

      return _processTasks;
    }()
  }, {
    key: "wantlistForPeer",
    value: function wantlistForPeer(peerId) {
      var peerIdStr = peerId.toB58String();

      if (!this.ledgerMap.has(peerIdStr)) {
        return new Map();
      }

      return this.ledgerMap.get(peerIdStr).wantlist.sortedEntries();
    }
  }, {
    key: "ledgerForPeer",
    value: function ledgerForPeer(peerId) {
      var peerIdStr = peerId.toB58String();
      var ledger = this.ledgerMap.get(peerIdStr);

      if (!ledger) {
        return null;
      }

      return {
        peer: ledger.partner.toPrint(),
        value: ledger.debtRatio(),
        sent: ledger.accounting.bytesSent,
        recv: ledger.accounting.bytesRecv,
        exchanged: ledger.exchangeCount
      };
    }
  }, {
    key: "peers",
    value: function peers() {
      return Array.from(this.ledgerMap.values()).map(function (l) {
        return l.partner;
      });
    } // Receive blocks either from an incoming message from the network, or from
    // blocks being added by the client on the localhost (eg IPFS add)

  }, {
    key: "receivedBlocks",
    value: function receivedBlocks(blocks) {
      var _this2 = this;

      if (!blocks.length) {
        return;
      } // For each connected peer, check if it wants the block we received


      this.ledgerMap.forEach(function (ledger) {
        blocks.forEach(function (block) {
          // Filter out blocks that we don't want
          var want = ledger.wantlistContains(block.cid);

          if (!want) {
            return;
          } // If the block is small enough, just send the block, even if the
          // client asked for a HAVE


          var blockSize = block.data.length;

          var isWantBlock = _this2._sendAsBlock(want.wantType, blockSize);

          var entrySize = blockSize;

          if (!isWantBlock) {
            entrySize = Message.blockPresenceSize(want.cid);
          }

          _this2._requestQueue.pushTasks(ledger.partner, [{
            topic: want.cid.toString(),
            priority: want.priority,
            size: entrySize,
            data: {
              blockSize: blockSize,
              isWantBlock: isWantBlock,
              haveBlock: true,
              sendDontHave: false
            }
          }]);
        });
      });

      this._scheduleProcessTasks();
    } // Handle incoming messages

  }, {
    key: "messageReceived",
    value: function () {
      var _messageReceived = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peerId, msg) {
        var ledger, cancels, wants;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ledger = this._findOrCreate(peerId);

                if (!msg.empty) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                // If the message has a full wantlist, clear the current wantlist
                if (msg.full) {
                  ledger.wantlist = new Wantlist();
                } // Record the amount of block data received


                this._updateBlockAccounting(msg.blocks, ledger);

                if (!(msg.wantlist.size === 0)) {
                  _context2.next = 8;
                  break;
                }

                this._scheduleProcessTasks();

                return _context2.abrupt("return");

              case 8:
                // Clear cancelled wants and add new wants to the ledger
                cancels = [];
                wants = [];
                msg.wantlist.forEach(function (entry) {
                  if (entry.cancel) {
                    ledger.cancelWant(entry.cid);
                    cancels.push(entry.cid);
                  } else {
                    ledger.wants(entry.cid, entry.priority, entry.wantType);
                    wants.push(entry);
                  }
                });

                this._cancelWants(peerId, cancels);

                _context2.next = 14;
                return this._addWants(peerId, wants);

              case 14:
                this._scheduleProcessTasks();

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function messageReceived(_x, _x2) {
        return _messageReceived.apply(this, arguments);
      }

      return messageReceived;
    }()
  }, {
    key: "_cancelWants",
    value: function _cancelWants(peerId, cids) {
      var _iterator4 = _createForOfIteratorHelper(cids),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var c = _step4.value;

          this._requestQueue.remove(c.toString(), peerId);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "_addWants",
    value: function () {
      var _addWants2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peerId, wants) {
        var blockSizes, tasks, _iterator5, _step5, want, id, blockSize, isWantBlock, entrySize;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._getBlockSizes(wants.map(function (w) {
                  return w.cid;
                }));

              case 2:
                blockSizes = _context3.sent;
                tasks = [];
                _iterator5 = _createForOfIteratorHelper(wants);

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    want = _step5.value;
                    id = want.cid.toString();
                    blockSize = blockSizes.get(id); // If the block was not found

                    if (blockSize == null) {
                      // Only add the task to the queue if the requester wants a DONT_HAVE
                      if (want.sendDontHave) {
                        tasks.push({
                          topic: id,
                          priority: want.priority,
                          size: Message.blockPresenceSize(want.cid),
                          data: {
                            isWantBlock: want.wantType === WantType.Block,
                            blockSize: 0,
                            haveBlock: false,
                            sendDontHave: want.sendDontHave
                          }
                        });
                      }
                    } else {
                      // The block was found, add it to the queue
                      // If the block is small enough, just send the block, even if the
                      // client asked for a HAVE
                      isWantBlock = this._sendAsBlock(want.wantType, blockSize); // entrySize is the amount of space the entry takes up in the
                      // message we send to the recipient. If we're sending a block, the
                      // entrySize is the size of the block. Otherwise it's the size of
                      // a block presence entry.

                      entrySize = blockSize;

                      if (!isWantBlock) {
                        entrySize = Message.blockPresenceSize(want.cid);
                      }

                      tasks.push({
                        topic: id,
                        priority: want.priority,
                        size: entrySize,
                        data: {
                          isWantBlock: isWantBlock,
                          blockSize: blockSize,
                          haveBlock: true,
                          sendDontHave: want.sendDontHave
                        }
                      });
                    }

                    this._requestQueue.pushTasks(peerId, tasks);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _addWants(_x3, _x4) {
        return _addWants2.apply(this, arguments);
      }

      return _addWants;
    }()
  }, {
    key: "_sendAsBlock",
    value: function _sendAsBlock(wantType, blockSize) {
      return wantType === WantType.Block || blockSize <= this._opts.maxSizeReplaceHasWithBlock;
    }
  }, {
    key: "_getBlockSizes",
    value: function () {
      var _getBlockSizes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cids) {
        var blocks;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._getBlocks(cids);

              case 2:
                blocks = _context4.sent;
                return _context4.abrupt("return", new Map(_toConsumableArray(blocks).map(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      k = _ref2[0],
                      v = _ref2[1];

                  return [k, v.data.length];
                })));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _getBlockSizes(_x5) {
        return _getBlockSizes2.apply(this, arguments);
      }

      return _getBlockSizes;
    }()
  }, {
    key: "_getBlocks",
    value: function () {
      var _getBlocks2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cids) {
        var _this3 = this;

        var res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                res = new Map();
                _context6.next = 3;
                return Promise.all(cids.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cid) {
                    var block;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return _this3.blockstore.get(cid);

                          case 3:
                            block = _context5.sent;
                            res.set(cid.toString(), block);
                            _context5.next = 10;
                            break;

                          case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5["catch"](0);

                            if (_context5.t0.code !== 'ERR_NOT_FOUND') {
                              _this3._log.error('failed to query blockstore for %s: %s', cid, _context5.t0);
                            }

                          case 10:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, null, [[0, 7]]);
                  }));

                  return function (_x7) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 3:
                return _context6.abrupt("return", res);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function _getBlocks(_x6) {
        return _getBlocks2.apply(this, arguments);
      }

      return _getBlocks;
    }()
  }, {
    key: "_updateBlockAccounting",
    value: function _updateBlockAccounting(blocksMap, ledger) {
      var _this4 = this;

      blocksMap.forEach(function (b) {
        _this4._log('got block (%s bytes)', b.data.length);

        ledger.receivedBytes(b.data.length);
      });
    } // Clear up all accounting things after message was sent

  }, {
    key: "messageSent",
    value: function messageSent(peerId, block) {
      var ledger = this._findOrCreate(peerId);

      ledger.sentBytes(block ? block.data.length : 0);

      if (block && block.cid) {
        ledger.wantlist.remove(block.cid);
      }
    }
  }, {
    key: "numBytesSentTo",
    value: function numBytesSentTo(peerId) {
      return this._findOrCreate(peerId).accounting.bytesSent;
    }
  }, {
    key: "numBytesReceivedFrom",
    value: function numBytesReceivedFrom(peerId) {
      return this._findOrCreate(peerId).accounting.bytesRecv;
    }
  }, {
    key: "peerDisconnected",
    value: function peerDisconnected(peerId) {// if (this.ledgerMap.has(peerId.toB58String())) {
      //   this.ledgerMap.delete(peerId.toB58String())
      // }
      //
      // TODO: figure out how to remove all other references
      // in the peer request queue
    }
  }, {
    key: "_findOrCreate",
    value: function _findOrCreate(peerId) {
      var peerIdStr = peerId.toB58String();

      if (this.ledgerMap.has(peerIdStr)) {
        return this.ledgerMap.get(peerIdStr);
      }

      var l = new Ledger(peerId);
      this.ledgerMap.set(peerIdStr, l);

      if (this._stats) {
        this._stats.push(peerIdStr, 'peerCount', 1);
      }

      return l;
    }
  }, {
    key: "start",
    value: function start() {
      this._running = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this._running = false;
    }
  }]);

  return DecisionEngine;
}();

module.exports = DecisionEngine;